import { ScrapbookFolder } from '@/api';
import FolderTreeNode from './FolderTreeNode';

interface FolderTreeViewProps {
  folders: ScrapbookFolder[];
  selectedFolderId: number;
  onFolderSelect: (folder: ScrapbookFolder) => void;
  draggingEnabled?: boolean;
  onDragStart?: (event: React.DragEvent, folder: ScrapbookFolder) => void;
  onDrop?: (event: React.DragEvent, folder: ScrapbookFolder) => void;
}

export default function FolderTreeView({
  folders,
  selectedFolderId,
  onFolderSelect,
  draggingEnabled = true,
  onDragStart,
  onDrop,
}: FolderTreeViewProps) {
  return (
    <div className="">
      {folders.map((folder, index) => (
        <FolderTreeNode
          key={index}
          folder={folder}
          level={0}
          selectedFolderId={selectedFolderId}
          onFolderSelect={onFolderSelect}
          draggingEnabled={draggingEnabled}
          onDragStart={onDragStart}
          onDrop={onDrop}
        />
      ))}
    </div>
  );
}
